import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`;

export const getTrainerProfile = async () => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.get(`${API_URL}auth/trainer-profile`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching trainer profile:', error);
        throw error;
    }
};

export const updateTrainerProfile = async (data) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        // Check if data contains a file (profile picture)
        let requestData;
        let headers = {
            Authorization: `Bearer ${accessToken}`
        };

        // If data includes profilePictureFile, use FormData
        if (data.profilePictureFile) {
            requestData = new FormData();
            Object.keys(data).forEach(key => {
                if (key === 'profilePictureFile') {
                    requestData.append('profilePicture', data[key]);
                } else if (data[key] !== undefined && data[key] !== null) {
                    // Handle JSON fields
                    if (typeof data[key] === 'object') {
                        requestData.append(key, JSON.stringify(data[key]));
                    } else {
                        requestData.append(key, data[key]);
                    }
                }
            });
            headers['Content-Type'] = 'multipart/form-data';
        } else {
            // Regular JSON data
            requestData = data;
            headers['Content-Type'] = 'application/json';
        }

        const response = await axios.patch(`${API_URL}auth/trainer-profile`, requestData, {
            headers
        });
        return response.data;
    } catch (error) {
        console.error('Error updating trainer profile:', error);
        throw error;
    }
};

export const uploadProfilePicture = async (file) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        const formData = new FormData();
        formData.append('profilePicture', file);

        const response = await axios.patch(`${API_URL}auth/trainer-profile`, formData, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading profile picture:', error);
        throw error;
    }
};

export const removeProfilePicture = async () => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.patch(`${API_URL}auth/trainer-profile`, {
            profilePicture: null
        }, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error removing profile picture:', error);
        throw error;
    }
};


